import { useEffect, useState, useRef, useCallback } from 'react';
import { flushSync } from 'react-dom';
import { useSearchParams } from 'react-router-dom';
import { KanbanColumn } from 'src/sections/@dashboard/negocios';
import { persistCard, persistColumn } from 'src/redux/slices/chat-kanban';
import { useDispatch, useSelector } from 'src/redux/store';
import { validaLabelMenuDatas, verifyRules } from 'src/utils/functions';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { getListaColunasCrm, getListaLeads, setLeadData } from 'src/redux/slices/crm';
import { fToNow } from 'src/utils/formatTime';
import { formataNumeroCelular } from 'src/utils/functions';
import useAuth from 'src/hooks/useAuth';
import v2_actionConfigCrm from 'src/actions/v2/crm/v2_actionConfigCrm';
import v2_actionEditarChat from 'src/actions/v2/chats/v2_actionEditarChat';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import v2_actionGerarExcelRelatorioNegocios from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioNegocios';
import ModalNovoNegocio from 'src/sections/@dashboard/cadastro/ModalNovoNegocio';
import ModalNegocio from 'src/sections/@dashboard/negocios/ModalNegocio';
import v2_actionCrmPesquisarLeads from 'src/actions/v2/crm/v2_actionCrmPesquisarLeads';
import { getChatInfoByChatId, getMensagensWhatsappDb, limparChats, setChatInfo, setMessage } from 'src/redux/slices/chat';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import Iconify from 'src/components/Iconify';
import { Card } from 'src/@/components/ui/card';
import { Table, TableHeader, TableHead, TableBody, TableRow, TableCell } from 'src/@/components/ui/table';
import { Badge } from 'src/@/components/ui/badge';
import { Button } from 'src/@/components/ui/button';
import { Input } from 'src/@/components/ui/input';
import { Eye, Search, X } from 'lucide-react';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'src/@/components/ui/select';
import { ReloadIcon } from "@radix-ui/react-icons";
import MenuDatas2 from 'src/components/MenuDatas2';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import PageContainerHeader from 'src/components/PageContainerHeader';

import 'moment/locale/pt-br';
moment.locale('pt-br');

// ----------------------------------------------------------------------

// Definição das colunas da tabela
const TABLE_HEAD = [
  { id: 'nome', label: 'Nome' },
  { id: 'nomeEstagio', label: 'Estágio' },
  { id: 'nomeUsuario', label: 'Responsável' },
  { id: 'qualificacao', label: 'Qualificação' },
  { id: 'valor', label: 'Valor' },
  { id: 'data_criacao', label: 'Data Criação' },
  { id: 'data_modificacao', label: 'Última Atividade' },
  { id: 'whatsapp_numero', label: 'Número WhatsApp' },
  { id: 'whatsapp_nome', label: 'Nome Contato' },
  { id: '' },
];

export default function Negocios() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { colunas, ordemColunas, lead, leadsKanban } = useSelector((state) => state.crm);

  // Estados para tabela
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);

  // Estados para filtros da tabela
  const [loadingKanban, setLoadingKanban] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [filterNome, setFilterNome] = useState('');
  const [filterEstagio, setFilterEstagio] = useState('');
  const [filterUsuario, setFilterUsuario] = useState('');
  const [filterQualificacao, setFilterQualificacao] = useState('');
  const [filterValor, setFilterValor] = useState('');
  const { negocio } = useSelector((state) => state.global);
  const { user, cliente } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();

  // Estados locais com valores padrão da URL
  const [inicial, setInicial] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const inicialRef = useRef(inicial);
  const finalRef = useRef(final);
  const [periodo, setPeriodo] = useState(searchParams.get('periodo') || 'mes_atual');
  const [listaClientesCanais, setListaClientesCanais] = useState([]);
  const [pipelineId, setPipelineId] = useState(searchParams.get('pipeline_id') || '');
  const [configCrm, setConfigCrm] = useState(null);
  const [qualificacao, setQualificacao] = useState(searchParams.get('qualificacao') || 'all');
  const [responsaveis, setResponsaveis] = useState(searchParams.get('responsaveis') || 'me');
  const [loadingModalCriarNegocio, setLoadingModalCriarNegocio] = useState(false);
  const [loadingExportExcel, setLoadingExportExcel] = useState(false);
  const [openModalCriarNegocio, setOpenModalCriarNegocio] = useState(false);
  const [openDrawerNegocio, setOpenDrawerNegocio] = useState(false);
  const [filterConvert, setFilterConvert] = useState(searchParams.get('filterConvert') || null);
  const [filterClosed, setFilterClosed] = useState(searchParams.get('filterClosed') || 'all');
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [usuarioSelected, setUsuarioSelected] = useState(searchParams.get('usuarioSelected') || null);
  const [viewMode, setViewMode] = useState('kanban');

  // Busca de lead (input com dropdown)
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const debounceRef = useRef(null);

  // Estados para o MenuDatas2
  const [anchorElMenuDatas, setAnchorElMenuDatas] = useState(null);
  const openMenuDatas = Boolean(anchorElMenuDatas);

  // Função para atualizar a URL com os parâmetros
  const updateURLParams = (newParams) => {
    const params = new URLSearchParams(searchParams);
    Object.entries(newParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    setSearchParams(params);
  };

  // Função para ler parâmetros da URL e atualizar estado
  const readURLParams = () => {
    const urlPeriodo = searchParams.get('periodo');
    const urlPipelineId = searchParams.get('pipeline_id');
    const urlQualificacao = searchParams.get('qualificacao');
    const urlResponsaveis = searchParams.get('responsaveis');
    const urlFilterConvert = searchParams.get('filterConvert');
    const urlFilterClosed = searchParams.get('filterClosed');
    const urlUsuarioSelected = searchParams.get('usuarioSelected');

    if (urlPeriodo) setPeriodo(urlPeriodo);
    if (urlPipelineId) setPipelineId(urlPipelineId);
    if (urlQualificacao) setQualificacao(urlQualificacao);
    if (urlResponsaveis) setResponsaveis(urlResponsaveis);
    if (urlFilterConvert) setFilterConvert(urlFilterConvert);
    if (urlFilterClosed) setFilterClosed(urlFilterClosed);
    if (urlUsuarioSelected) setUsuarioSelected(urlUsuarioSelected);
  };

  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        let data = result.data.data;
        if (data.pipelines.length > 0 && !pipelineId) {
          const newPipelineId = data.pipelines[0]._id;
          setPipelineId(newPipelineId);
          updateURLParams({ pipeline_id: newPipelineId });
          handleListaChatsFunil(periodo, newPipelineId, qualificacao, responsaveis);
        }
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function buscarConfigCrmSemAlterarPipeline(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const buscarUsuarios = async () => {
    try {
      const res = await getActionListaUsuariosByClienteId(user.clienteId);
      setListaUsuarios(res.data.usuarios);
    } catch (error) {
      console.log(error);
    }
  };

  async function buscarListaClientesCanais() {
    try {
      const response_clientes_canais = await actionListaClientesCanais(cliente._id);
      setListaClientesCanais(response_clientes_canais.data.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function handleListaChatsFunil(periodo, pipelineId, qualificacao, responsaveis, querysData, showLoader = true) {
    try {
      if (showLoader) setIsLoadingData(true);

      let inicio2 = moment(inicial).format("YYYY-MM-DD");
      let final2 = moment(final).format("YYYY-MM-DD");
      let querys = querysData ? querysData : `?periodo=${periodo}&usuario_id=${user.id}&cliente_id=${user.clienteId}&data_inicial=${inicio2}&data_final=${final2}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${responsaveis}`;

      updateURLParams({
        periodo,
        pipeline_id: pipelineId,
        qualificacao,
        responsaveis,
        filterConvert,
        filterClosed,
        usuarioSelected
      });

      await Promise.all([
        dispatch(getListaLeads(querys)),
        dispatch(getListaColunasCrm(querys))
      ]);
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoadingData(false);
    }
  }

  useEffect(() => {
    readURLParams();
    buscarConfigCrm();
    buscarListaClientesCanais();
    buscarUsuarios();
    handleListaChatsFunil(periodo, pipelineId, qualificacao, responsaveis);
  }, [dispatch]);

  async function editarLead(action, value, leadId) {
    if (action === "editar_estagio_funil") {
      let data = {
        action: action,
        scope: {
          estagio_pipeline_id: value,
        }
      };
      await v2_actionEditarLead(leadId, data, user.id);
      enqueueSnackbar('Estágio alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
    }
  }

  const onDragEnd = async (result) => {
    const { destination, source, draggableId, type } = result;

    if (type === 'column') return;
    if (!destination) return;
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    const start = colunas[source.droppableId];
    const finish = colunas[destination.droppableId];
    const previousColunas = colunas;

    if (start.id === finish.id) {
      flushSync(() => {
        dispatch(
          persistCard({
            ...colunas,
            [start.id]: { ...start, leadIds: [...start.leadIds] },
          })
        );
      });
      return;
    }

    const startCardIds = start.leadIds.filter((id) => id !== draggableId);
    const finishCardIds = finish.leadIds.includes(draggableId)
      ? finish.leadIds
      : [...finish.leadIds, draggableId];

    flushSync(() => {
      dispatch(
        persistCard({
          ...colunas,
          [start.id]: { ...start, leadIds: startCardIds },
          [finish.id]: { ...finish, leadIds: finishCardIds },
        })
      );
    });

    try {
      await editarLead("editar_estagio_funil", destination.droppableId, draggableId);
      handleListaChatsFunil(periodo, pipelineId, qualificacao, responsaveis, null, false);
    } catch (err) {
      dispatch(persistCard(previousColunas));
      enqueueSnackbar('Não foi possível mover o lead. Tente novamente.', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
      });
    }
  };

  async function handlOpenLead(data) {
    dispatch(setLeadData(data));
  }

  const handleSelectLead = (leadData) => {
    if (leadData.whatsapp) {
      dispatch(getMensagensWhatsappDb(leadData.whatsapp.sessao, leadData.whatsapp.numero, 1, 10));
    }
    handlOpenLead(leadData);

    let querys = `?pipeline_id=${leadData.crm_pipeline_id}`;
    buscarConfigCrmSemAlterarPipeline(querys);
    setOpenDrawerNegocio(true);

    setShowSearchDropdown(false);
    setSearchTerm('');
    setSearchResults([]);
  };

  const handleExportToExcel = async () => {
    try {
      setLoadingExportExcel(true);
      let inicio2 = moment(inicial).format("YYYY-MM-DD");
      let final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&usuario_id=${user.id}&cliente_id=${user.clienteId}&data_inicial=${inicio2}&data_final=${final2}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${responsaveis}`;

      const response = await v2_actionGerarExcelRelatorioNegocios(querys);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `negocios_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.log('Erro ao exportar negócios:', error);
    } finally {
      setLoadingExportExcel(false);
    }
  };

  // Efeito de busca (debounce)
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!searchTerm || searchTerm.trim().length < 3) {
      setSearchResults([]);
      setSearchError(null);
      setShowSearchDropdown(!!searchTerm);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      try {
        setSearchLoading(true);
        setSearchError(null);

        const queryParams = new URLSearchParams({
          cliente_id: user.clienteId,
          termo_pesquisa: searchTerm.trim(),
          limite: 20
        });

        const querys = `?${queryParams.toString()}`;
        const response = await v2_actionCrmPesquisarLeads(querys);
        const leads = response.data?.data || [];
        setSearchResults(Array.isArray(leads) ? leads : Object.values(leads));
        setShowSearchDropdown(true);
      } catch (e) {
        setSearchError('Não foi possível buscar.');
        setSearchResults([]);
        setShowSearchDropdown(true);
      } finally {
        setSearchLoading(false);
      }
    }, 300);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchTerm]);

  // Resetar página quando filtros mudarem
  useEffect(() => {
    setPage(1);
  }, [filterNome, filterEstagio, filterUsuario, filterQualificacao, filterValor]);

  // Função para converter dados do kanban para tabela
  const getTableData = () => {
    if (!leadsKanban) return [];

    const allLeads = Object.values(leadsKanban);

    let filteredLeads = allLeads.filter((lead) => {
      if (!lead) return false;

      if (filterConvert === 1 && lead.convertido !== 1) return false;
      if (filterConvert === 2 && lead.convertido !== 2) return false;
      if (filterClosed === true && lead.closed !== true) return false;
      if (filterClosed === false && lead.closed !== false) return false;

      if (filterNome && !lead.nome?.toLowerCase().includes(filterNome.toLowerCase())) return false;
      if (filterEstagio && !lead.nomeEstagio?.toLowerCase().includes(filterEstagio.toLowerCase())) return false;
      if (filterUsuario && !lead.nomeUsuario?.toLowerCase().includes(filterUsuario.toLowerCase())) return false;
      if (filterQualificacao && lead.qualificacao !== parseInt(filterQualificacao)) return false;
      if (filterValor && !lead.valor?.toString().includes(filterValor)) return false;

      return true;
    });

    return filteredLeads;
  };

  const tableData = getTableData();

  const allLeadsArray = leadsKanban ? Object.values(leadsKanban) : [];
  const uniqueEstagios = Array.from(new Set(allLeadsArray.map((l) => l?.nomeEstagio).filter(Boolean)));
  const uniqueUsuarios = Array.from(new Set(allLeadsArray.map((l) => l?.nomeUsuario).filter(Boolean)));

  const [showEstagioFilter, setShowEstagioFilter] = useState(false);
  const [showUsuarioFilter, setShowUsuarioFilter] = useState(false);

  const handleChangePage = (newPage) => setPage(newPage);
  const handleChangeLimit = (newLimit) => { setLimit(newLimit); setPage(1); };

  const clearAllFilters = () => {
    setFilterNome('');
    setFilterEstagio('');
    setFilterUsuario('');
    setFilterQualificacao('');
    setFilterValor('');
    setPage(1);
  };

  const formatCurrency = (value) => {
    if (!value) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return moment(date).format('DD/MM/YYYY HH:mm');
  };

  const getQualificacaoColor = (qual) => {
    switch (qual) {
      case 1: return 'bg-blue-50 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-500/20';
      case 2: return 'bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-500/20';
      case 3: return 'bg-orange-50 dark:bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-200 dark:border-orange-500/20';
      case 4: return 'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 border-red-200 dark:border-red-500/20';
      case 5: return 'bg-violet-50 dark:bg-violet-500/10 text-violet-700 dark:text-violet-400 border-violet-200 dark:border-violet-500/20';
      default: return 'bg-gray-50 dark:bg-[#383838] text-gray-600 dark:text-[#ABABAD] border-gray-200 dark:border-[#383838]';
    }
  };

  const getQualificacaoLabel = (qual) => {
    switch (qual) {
      case 1: return 'Baixa';
      case 2: return 'Média';
      case 3: return 'Alta';
      case 4: return 'Muito Alta';
      case 5: return 'Crítica';
      default: return 'N/D';
    }
  };

  const totalPages = Math.ceil(tableData.length / limit);

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <ModalNovoNegocio
        open={openModalCriarNegocio}
        cliente={cliente}
        user={user}
        callbackAddContact={() => { }}
        onClose={() => {
          setOpenModalCriarNegocio(false);
          setLoadingModalCriarNegocio(false);
        }}
      />

      <ModalNegocio
        open={openDrawerNegocio}
        onClose={() => {
          setOpenDrawerNegocio(false);
          dispatch(setChatInfo(null));
          dispatch(limparChats([]));
          dispatch(setLeadData(null));
        }}
        cliente={cliente}
        user={user}
        configCrm={configCrm}
        lead={lead}
        callbackRefreshLeads={() => handleListaChatsFunil(periodo, pipelineId, qualificacao, responsaveis)}
        onSelect={(cardId) => {
          let leadContent = leadsKanban[cardId];
          handlOpenLead(leadContent);
          let querys = `?pipeline_id=${leadContent.crm_pipeline_id}`;
          buscarConfigCrmSemAlterarPipeline(querys);
          setOpenDrawerNegocio(true);
          dispatch(getMensagensWhatsappDb(leadContent.clienteWhatsapp.sessao, leadContent.clienteWhatsapp.numero, 1, 10));
        }}
      />

      {/* Header */}
      <PageContainerHeader
        separatorClassName="hidden xl:block"
        titleSection={
          <div className="hidden xl:flex items-center gap-2 min-w-fit">
            <div className="p-2 bg-[#7C3AED]/10 rounded-lg">
              <Iconify icon="mdi:view-dashboard" className="text-[#7C3AED]" width={20} />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">Negócios</h3>
            </div>
          </div>
        }
        middleSection={
          <div className="flex flex-wrap items-end gap-2 flex-1">
            {/* Período */}
            <div className="w-full sm:w-[200px]">
              <span className="text-[10px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1 block pl-1">Período</span>
              <MenuDatas2
                anchorEl={anchorElMenuDatas}
                open={openMenuDatas}
                onClose={() => setAnchorElMenuDatas(null)}
                inicial={inicial}
                final={final}
                content={validaLabelMenuDatas(periodo, inicial, final)}
                customButton={
                  <Button
                    variant="outline"
                    className="w-full h-9 justify-between text-xs font-normal border-dashed border-gray-300 dark:border-[#383838] bg-transparent hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 text-gray-700 dark:text-[#D1D2D3]"
                    onClick={(e) => setAnchorElMenuDatas(e.currentTarget)}
                  >
                    <span className="truncate">{validaLabelMenuDatas(periodo, inicial, final)}</span>
                    <Iconify icon="mdi:calendar" className="ml-2 h-3.5 w-3.5 opacity-50" />
                  </Button>
                }
                changeInicial={newValue => {
                  setInicial(newValue);
                  inicialRef.current = newValue;
                  updateURLParams({ data_inicial: moment(newValue).format("YYYY-MM-DD") });
                }}
                changeFinal={newValue => {
                  setFinal(newValue);
                  finalRef.current = newValue;
                  updateURLParams({ data_final: moment(newValue).format("YYYY-MM-DD") });
                }}
                onSelect={value => { }}
                onPesquisar={() => {
                  let inicio2 = moment(inicialRef.current).format("YYYY-MM-DD");
                  let final2 = moment(finalRef.current).format("YYYY-MM-DD");
                  setPeriodo('custom');
                  updateURLParams({ periodo: 'custom', data_inicial: inicio2, data_final: final2 });
                  let querys = `?periodo=custom&usuario_id=${user.id}&cliente_id=${user.clienteId}&data_inicial=${inicio2}&data_final=${final2}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${responsaveis}`;
                  handleListaChatsFunil('custom', pipelineId, qualificacao, responsaveis, querys);
                }}
              />
            </div>

            {/* Pipeline */}
            <div className="w-full sm:w-[160px]">
              <span className="text-[10px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1 block pl-1">Funil</span>
              <Select
                value={pipelineId}
                onValueChange={(value) => {
                  setPipelineId(value);
                  updateURLParams({ pipeline_id: value });
                  let querys = `?periodo=${periodo}&usuario_id=${value}&cliente_id=${user.clienteId}&pipeline_id=${value}&qualificacao=${qualificacao}&responsaveis=${responsaveis}`;
                  handleListaChatsFunil(periodo, value, qualificacao, responsaveis, querys);
                }}
              >
                <SelectTrigger className="h-9 text-xs border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3] focus:ring-[#7C3AED]/20">
                  <SelectValue placeholder="Selecione o funil" />
                </SelectTrigger>
                <SelectContent>
                  {configCrm?.pipelines?.map((pipeline) => (
                    <SelectItem key={pipeline._id} value={pipeline._id}>{pipeline.nome}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Visualização */}
            {verifyRules(user.rules, "supervisionar_leads") && (
              <div className="w-full sm:w-[140px]">
                <span className="text-[10px] font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1 block pl-1">Visualização</span>
                <Select
                  value={responsaveis}
                  onValueChange={(value) => {
                    setUsuarioSelected(null);
                    setResponsaveis(value);
                    updateURLParams({ responsaveis: value, usuarioSelected: null });
                    handleListaChatsFunil(periodo, pipelineId, qualificacao, value);
                  }}
                >
                  <SelectTrigger className="h-9 text-xs border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3] focus:ring-[#7C3AED]/20">
                    <SelectValue placeholder="Visualização" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="me">Meus Leads</SelectItem>
                    <SelectItem value="all">Todos Leads</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            )}

            {/* Mais Filtros */}
            <div className="flex items-end">
              <Popover>
                <PopoverTrigger asChild>
                  <Button variant="outline" className="h-9 px-3 border-dashed border-gray-300 dark:border-[#383838] text-xs text-gray-600 dark:text-[#ABABAD] hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 bg-transparent">
                    <Iconify icon="mdi:filter-plus" className="mr-2 h-4 w-4" />
                    Mais filtros
                    {(filterConvert !== null || (filterClosed !== 'all' && filterClosed !== null) || (qualificacao !== 'all') || (usuarioSelected !== null)) && (
                      <span className="ml-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-violet-100 dark:bg-violet-500/20 text-[10px] font-medium text-violet-800 dark:text-violet-300">
                        {(filterConvert !== null ? 1 : 0) + ((filterClosed !== 'all' && filterClosed !== null) ? 1 : 0) + (qualificacao !== 'all' ? 1 : 0) + (usuarioSelected !== null ? 1 : 0)}
                      </span>
                    )}
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-80 p-4 dark:bg-[#222529] dark:border-[#383838]" align="start">
                  <div className="space-y-4">
                    <h4 className="font-medium text-sm text-gray-900 dark:text-[#D1D2D3] border-b border-gray-200 dark:border-[#383838] pb-2">Filtros Adicionais</h4>

                    <div className="space-y-3">
                      {verifyRules(user.rules, "supervisionar_leads") && (
                        <div>
                          <label className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">Por Usuário</label>
                          <Select
                            value={usuarioSelected || "clear"}
                            onValueChange={(value) => {
                              if (value === 'clear') {
                                setUsuarioSelected(null);
                                setResponsaveis(null);
                                updateURLParams({ usuarioSelected: null, responsaveis: null });
                                let querys = `?periodo=${periodo}&usuario_id=${user.id}&cliente_id=${user.clienteId}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${null}`;
                                handleListaChatsFunil(value, pipelineId, qualificacao, responsaveis, querys);
                                return;
                              }
                              setResponsaveis(null);
                              setUsuarioSelected(value);
                              updateURLParams({ usuarioSelected: value, responsaveis: null });
                              let querys = `?periodo=${periodo}&usuario_id=${value}&cliente_id=${user.clienteId}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${null}`;
                              handleListaChatsFunil(value, pipelineId, qualificacao, responsaveis, querys);
                            }}
                          >
                            <SelectTrigger className="h-9 text-xs w-full border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3] focus:ring-[#7C3AED]/20">
                              <SelectValue placeholder="Selecione um usuário" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="clear">Limpar filtro</SelectItem>
                              {listaUsuarios.map((item) => (
                                <SelectItem key={item._id} value={item._id}>{item.nomeFantasia}</SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                      )}

                      <div>
                        <label className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">Qualificação</label>
                        <Select
                          value={qualificacao}
                          onValueChange={(value) => {
                            setQualificacao(value);
                            updateURLParams({ qualificacao: value });
                            handleListaChatsFunil(periodo, pipelineId, value, responsaveis);
                          }}
                        >
                          <SelectTrigger className="h-9 text-xs w-full border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3] focus:ring-[#7C3AED]/20">
                            <SelectValue placeholder="Qualificação" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todas as Qualificações</SelectItem>
                            {configCrm?.qualificacoes?.map((item) => (
                              <SelectItem key={item.value} value={item.value}>{item.nome}</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>

                      <div>
                        <label className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">Status Venda</label>
                        <Select
                          value={filterConvert?.toString() || "all"}
                          onValueChange={(value) => {
                            let v = value === "all" ? null : parseInt(value);
                            setFilterConvert(v);
                            updateURLParams({ filterConvert: v });
                          }}
                        >
                          <SelectTrigger className="h-9 text-xs w-full border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3] focus:ring-[#7C3AED]/20">
                            <SelectValue placeholder="Status Venda" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todas as Vendas</SelectItem>
                            <SelectItem value="1">Venda Realizada</SelectItem>
                            <SelectItem value="2">Perda</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      <div>
                        <label className="text-xs font-semibold text-gray-500 dark:text-[#ABABAD] uppercase tracking-wider mb-1.5 block">Status do Lead</label>
                        <Select
                          value={filterClosed?.toString()}
                          onValueChange={(value) => {
                            let v = value === "true" ? true : value === "false" ? false : "all";
                            setFilterClosed(v);
                            updateURLParams({ filterClosed: v });
                          }}
                        >
                          <SelectTrigger className="h-9 text-xs w-full border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3] focus:ring-[#7C3AED]/20">
                            <SelectValue placeholder="Status Aberto" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">Todas</SelectItem>
                            <SelectItem value="false">Em Aberto</SelectItem>
                            <SelectItem value="true">Finalizados</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            </div>

            {/* Pesquisa */}
            <div className="relative w-full sm:w-[220px] mb-2 ml-auto flex flex-col justify-end" onBlur={(e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) {
                setShowSearchDropdown(false);
              }
            }}>
              <Input
                className="pl-9 h-9 bg-slate-50 dark:bg-[#1A1D21] border-gray-200 dark:border-[#383838] focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 hover:border-[#7C3AED]/50 transition-all text-xs rounded-lg dark:text-[#D1D2D3] dark:placeholder-[#ABABAD]"
                placeholder="Buscar lead..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setShowSearchDropdown(true);
                }}
                onFocus={() => setShowSearchDropdown(!!searchTerm)}
              />
              <Iconify icon="fluent:search-12-filled" className="absolute left-3 bottom-[10px] text-gray-400 dark:text-[#ABABAD]" width={16} />

              {/* Dropdown de Resultados */}
              {showSearchDropdown && (
                <div className="absolute top-full z-[9999] mt-1.5 w-[calc(100vw-2rem)] sm:w-[360px] right-0 rounded-xl border border-gray-200 dark:border-[#383838] bg-white dark:bg-[#222529] shadow-2xl max-h-[420px] overflow-hidden flex flex-col">
                  {/* Header do dropdown */}
                  <div className="px-3 py-2 border-b border-gray-100 dark:border-[#383838] bg-gray-50/50 dark:bg-[#1A1D21]/50 flex items-center justify-between shrink-0">
                    <span className="text-[10px] font-semibold text-gray-400 dark:text-[#ABABAD] uppercase tracking-wider">
                      {searchLoading ? 'Buscando...' : searchResults.length > 0 ? `${searchResults.length} resultado${searchResults.length !== 1 ? 's' : ''}` : 'Pesquisa'}
                    </span>
                    {searchTerm && (
                      <button
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => { setSearchTerm(''); setSearchResults([]); setShowSearchDropdown(false); }}
                        className="text-gray-400 hover:text-gray-600 dark:hover:text-[#D1D2D3] transition-colors"
                      >
                        <Iconify icon="eva:close-outline" width={14} />
                      </button>
                    )}
                  </div>

                  <div className="overflow-y-auto flex-1">
                    {searchLoading ? (
                      <div className="p-4 space-y-3">
                        {[1, 2, 3].map((i) => (
                          <div key={i} className="flex items-center gap-3 animate-pulse">
                            <div className="w-8 h-8 rounded-lg bg-gray-100 dark:bg-[#383838] shrink-0" />
                            <div className="flex-1 space-y-1.5">
                              <div className="h-3 w-2/3 bg-gray-100 dark:bg-[#383838] rounded" />
                              <div className="h-2.5 w-1/3 bg-gray-100 dark:bg-[#383838] rounded" />
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : searchError ? (
                      <div className="p-6 text-center">
                        <Iconify icon="eva:alert-circle-outline" width={24} className="text-red-400 mx-auto mb-2" />
                        <p className="text-xs text-red-500">{searchError}</p>
                      </div>
                    ) : searchTerm.trim().length < 3 ? (
                      <div className="p-6 text-center">
                        <Iconify icon="eva:search-outline" width={24} className="text-gray-300 dark:text-[#ABABAD]/30 mx-auto mb-2" />
                        <p className="text-xs text-gray-400 dark:text-[#ABABAD]">Digite 3+ caracteres para buscar</p>
                      </div>
                    ) : searchResults.length === 0 ? (
                      <div className="p-6 text-center">
                        <Iconify icon="eva:inbox-outline" width={24} className="text-gray-300 dark:text-[#ABABAD]/30 mx-auto mb-2" />
                        <p className="text-xs text-gray-400 dark:text-[#ABABAD]">Nenhum lead encontrado</p>
                      </div>
                    ) : (
                      <div className="p-1.5">
                        {searchResults.map((item) => (
                          <div
                            key={item._id}
                            className="px-3 py-2.5 hover:bg-violet-50 dark:hover:bg-violet-500/10 rounded-lg cursor-pointer transition-all group"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleSelectLead(item);
                            }}
                          >
                            <div className="flex items-start gap-2.5">
                              {/* Avatar / Iniciais */}
                              <div className="w-8 h-8 rounded-lg bg-violet-100 dark:bg-violet-500/15 flex items-center justify-center text-[10px] font-bold text-violet-600 dark:text-violet-400 shrink-0 mt-0.5">
                                {item?.nome ? item.nome.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() : '?'}
                              </div>

                              <div className="flex-1 min-w-0">
                                {/* Nome + Valor */}
                                <div className="flex items-center justify-between gap-2">
                                  <p className="text-[13px] font-semibold text-gray-900 dark:text-[#D1D2D3] truncate group-hover:text-[#7C3AED] transition-colors">
                                    {item?.nome || 'Sem nome'}
                                  </p>
                                  {item?.valor > 0 && (
                                    <span className="text-[11px] font-bold text-gray-900 dark:text-[#D1D2D3] shrink-0">
                                      R$ {item.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                    </span>
                                  )}
                                </div>

                                {/* Info linha */}
                                <div className="flex items-center gap-2 mt-1 flex-wrap">
                                  {item?.whatsapp?.numero && (
                                    <span className="inline-flex items-center gap-1 text-[10px] text-gray-500 dark:text-[#ABABAD]">
                                      <Iconify icon="ri:whatsapp-fill" className="text-green-500" width={11} />
                                      {formataNumeroCelular(item.whatsapp.numero)}
                                    </span>
                                  )}
                                  {item?.contato?.telefone && !item?.whatsapp?.numero && (
                                    <span className="inline-flex items-center gap-1 text-[10px] text-gray-500 dark:text-[#ABABAD]">
                                      <Iconify icon="eva:phone-outline" width={11} />
                                      {formataNumeroCelular(item.contato.telefone)}
                                    </span>
                                  )}
                                  {item?.nomeEstagio && (
                                    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider rounded bg-violet-100/80 text-violet-600 dark:bg-violet-500/15 dark:text-violet-400">
                                      {item.nomeEstagio}
                                    </span>
                                  )}
                                  {item?.nomeUsuario && (
                                    <span className="inline-flex items-center gap-1 text-[10px] text-gray-400 dark:text-[#ABABAD]/70">
                                      <Iconify icon="mdi:account-outline" width={11} />
                                      {item.nomeUsuario}
                                    </span>
                                  )}
                                </div>

                                {/* Data */}
                                {item?.data_modificacao && (
                                  <p className="text-[10px] text-gray-400 dark:text-[#ABABAD]/60 mt-1">
                                    Atualizado {fToNow(item.data_modificacao)}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        }
        rightSection={
          <div className="flex items-center gap-2">
            {/* View Mode Toggle */}
            <div className="flex items-center bg-gray-50 dark:bg-[#1A1D21] rounded-lg border border-gray-200 dark:border-[#383838] p-0.5">
              <button
                onClick={() => setViewMode('kanban')}
                className={`px-2 py-1 rounded-md text-xs font-medium transition-all ${viewMode === 'kanban' ? 'bg-[#7C3AED]/10 text-[#7C3AED]' : 'text-gray-500 dark:text-[#ABABAD] hover:text-gray-700 dark:hover:text-[#D1D2D3]'}`}
              >
                <Iconify icon="mdi:view-column-outline" width={16} />
              </button>
              <button
                onClick={() => setViewMode('table')}
                className={`px-2 py-1 rounded-md text-xs font-medium transition-all ${viewMode === 'table' ? 'bg-[#7C3AED]/10 text-[#7C3AED]' : 'text-gray-500 dark:text-[#ABABAD] hover:text-gray-700 dark:hover:text-[#D1D2D3]'}`}
              >
                <Iconify icon="mdi:format-list-bulleted" width={16} />
              </button>
            </div>

            {/* Export Excel */}
            <Button
              variant="outline"
              size="icon"
              className="h-9 w-9 border-dashed border-gray-300 dark:border-[#383838] hover:border-green-500 hover:text-green-600 hover:bg-green-50 dark:hover:bg-green-500/10 text-gray-600 dark:text-[#ABABAD] bg-transparent"
              onClick={handleExportToExcel}
              disabled={loadingExportExcel}
              title="Exportar Excel"
            >
              {loadingExportExcel ? <ReloadIcon className="animate-spin h-4 w-4" /> : <Iconify icon="file-icons:microsoft-excel" className="h-4 w-4" />}
            </Button>

            <Button
              onClick={() => setOpenModalCriarNegocio(true)}
              title="Novo Negócio"
              className="h-9 w-9 xl:w-auto xl:px-3 gap-2 bg-[#7C3AED] hover:bg-[#6D28D9] text-white shadow-lg shadow-violet-500/20 text-xs font-semibold rounded-lg transition-all hover:scale-105 active:scale-95"
            >
              <Iconify icon="fluent:add-12-filled" /> <span className="hidden xl:inline">Novo Negócio</span>
            </Button>
          </div>
        }
      />


      {/* Content */}
      <div className="px-6 pb-6 pt-3 flex-1 min-h-0 overflow-hidden flex flex-col">
        {isLoadingData ? (
          viewMode === 'kanban' ? (
            // Kanban Skeleton
            <div className="flex flex-row gap-4 overflow-x-auto pb-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="min-w-[280px] w-[300px] rounded-2xl bg-gray-50/80 dark:bg-[#1A1D21]/60 p-4">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 rounded-full bg-gray-200 dark:bg-[#383838] animate-pulse" />
                      <div className="h-4 w-24 bg-gray-200 dark:bg-[#383838] rounded animate-pulse" />
                    </div>
                    <div className="h-5 w-5 bg-gray-200 dark:bg-[#383838] rounded-full animate-pulse" />
                  </div>
                  <div className="space-y-2.5">
                    {[1, 2, 3].map((j) => (
                      <div key={j} className="bg-slate-50 dark:bg-[#222529] rounded-xl border border-gray-100 dark:border-[#383838] p-3.5 animate-pulse">
                        <div className="flex items-center justify-between mb-3">
                          <div className="h-3 w-16 bg-gray-200 dark:bg-[#383838] rounded" />
                          <div className="h-3 w-12 bg-gray-200 dark:bg-[#383838] rounded" />
                        </div>
                        <div className="h-4 w-3/4 bg-gray-200 dark:bg-[#383838] rounded mb-2" />
                        <div className="h-3 w-1/2 bg-gray-200 dark:bg-[#383838] rounded mb-3" />
                        <div className="flex items-center justify-between pt-2 border-t border-gray-50 dark:border-[#383838]/50">
                          <div className="flex items-center gap-2">
                            <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-[#383838]" />
                            <div className="h-3 w-20 bg-gray-200 dark:bg-[#383838] rounded" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // Table Skeleton
            <Card className="rounded-2xl shadow-sm border border-gray-100 dark:border-[#383838] dark:bg-[#222529] overflow-hidden">
              <div className="flex flex-col items-center justify-center h-64 text-gray-400 dark:text-[#ABABAD]">
                <Iconify icon="mdi:loading" className="w-8 h-8 animate-spin mb-4 text-[#7C3AED]" />
                <p className="text-sm font-medium">Carregando negócios...</p>
              </div>
            </Card>
          )
        ) : viewMode === 'kanban' ? (
          // Kanban View
          leadsKanban ? (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="all-columns" direction="horizontal" type="column" isDropDisabled={true}>
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="flex flex-row gap-2 overflow-x-auto pb-4 flex-1 min-h-0 h-full"
                  >
                    {!ordemColunas.length ? (
                      <Card className="rounded-2xl shadow-sm border border-gray-100 dark:border-[#383838] dark:bg-[#222529] overflow-hidden w-full">
                        <div className="flex flex-col items-center justify-center p-12 text-center">
                          <div className="w-16 h-16 bg-gray-50 dark:bg-[#1A1D21] rounded-full flex items-center justify-center mb-4 text-gray-400 dark:text-[#ABABAD]">
                            <Iconify icon="mdi:view-dashboard-outline" width={32} />
                          </div>
                          <h3 className="text-lg font-bold text-gray-900 dark:text-[#D1D2D3] mb-2">Nenhum lead encontrado</h3>
                          <p className="text-gray-500 dark:text-[#ABABAD] max-w-sm">Não encontramos nenhum lead por aqui. Tente ajustar os filtros ou criar um novo negócio.</p>
                        </div>
                      </Card>
                    ) : (
                      colunas &&
                      ordemColunas.map((columnId, index) => {
                        const colunaAtual = colunas[columnId];

                        const leadsFiltrados = colunaAtual.leadIds.filter((leadId) => {
                          const lead = leadsKanban[leadId];
                          if (!lead) return false;
                          if (filterConvert === 1 && lead.convertido !== 1) return false;
                          if (filterConvert === 2 && lead.convertido !== 2) return false;
                          if (filterClosed === true && lead.closed !== true) return false;
                          if (filterClosed === false && lead.closed !== false) return false;
                          return true;
                        });

                        return (
                          <KanbanColumn
                            key={columnId}
                            user={user}
                            loadingKanban={loadingKanban}
                            cliente={cliente}
                            configCrm={configCrm}
                            callbackRefreshLeads={() => handleListaChatsFunil(periodo, pipelineId, qualificacao, responsaveis)}
                            index={parseInt(index, 10)}
                            column={{ ...colunaAtual, leadIds: leadsFiltrados }}
                            onSelect={(cardId) => {
                              let leadContent = leadsKanban[cardId];
                              handlOpenLead(leadContent);
                              let querys = `?pipeline_id=${leadContent.crm_pipeline_id}`;
                              buscarConfigCrmSemAlterarPipeline(querys);
                              setOpenDrawerNegocio(true);
                            }}
                          />
                        );
                      })
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          ) : (
            <Card className="rounded-2xl shadow-sm border border-gray-100 dark:border-[#383838] dark:bg-[#222529] overflow-hidden">
              <div className="flex flex-col items-center justify-center p-12 text-center">
                <div className="w-16 h-16 bg-gray-50 dark:bg-[#1A1D21] rounded-full flex items-center justify-center mb-4 text-gray-400 dark:text-[#ABABAD]">
                  <Iconify icon="mdi:view-dashboard-outline" width={32} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-[#D1D2D3] mb-2">Nenhum lead encontrado</h3>
                <p className="text-gray-500 dark:text-[#ABABAD] max-w-sm">Não encontramos nenhum lead por aqui.</p>
              </div>
            </Card>
          )
        ) : (
          // Table View
          <Card className="rounded-2xl shadow-sm border border-gray-100 dark:border-[#383838] dark:bg-[#222529] overflow-hidden">
            {tableData.length === 0 ? (
              <div className="flex flex-col items-center justify-center p-12 text-center">
                <div className="w-16 h-16 bg-gray-50 dark:bg-[#1A1D21] rounded-full flex items-center justify-center mb-4 text-gray-400 dark:text-[#ABABAD]">
                  <Iconify icon="mdi:table-off" width={32} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-[#D1D2D3] mb-2">Nenhum lead encontrado</h3>
                <p className="text-gray-500 dark:text-[#ABABAD] max-w-sm mb-4">Nenhum lead corresponde aos filtros aplicados.</p>
                {(filterNome || filterEstagio || filterUsuario || filterQualificacao || filterValor) && (
                  <Button variant="link" className="text-[#7C3AED] font-medium" onClick={clearAllFilters}>
                    Limpar filtros da tabela
                  </Button>
                )}
              </div>
            ) : (
              <>
                <div className="overflow-auto" style={{ maxHeight: 'calc(100vh - 380px)' }}>
                  <Table>
                    <TableHeader className="bg-gray-50/80 dark:bg-[#1A1D21]/50 sticky top-0 z-10">
                      <TableRow>
                        {TABLE_HEAD.map((head) => (
                          <TableHead key={head.id} className="text-[11px] font-bold uppercase tracking-wider text-gray-500 dark:text-[#ABABAD]">
                            <div className="flex items-center gap-1 relative">
                              <span>{head.label}</span>
                              {(head.id === 'nomeEstagio' || head.id === 'nomeUsuario') && (
                                <>
                                  {(() => {
                                    const isFiltered = head.id === 'nomeEstagio' ? !!filterEstagio : head.id === 'nomeUsuario' ? !!filterUsuario : false;
                                    return (
                                      <Button
                                        variant="ghost"
                                        size="icon"
                                        className={`h-6 w-6 p-0 ${isFiltered ? 'bg-violet-50 dark:bg-violet-500/10' : ''}`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (head.id === 'nomeEstagio') {
                                            setShowEstagioFilter((v) => !v);
                                            setShowUsuarioFilter(false);
                                          } else if (head.id === 'nomeUsuario') {
                                            setShowUsuarioFilter((v) => !v);
                                            setShowEstagioFilter(false);
                                          }
                                        }}
                                        title={`Filtrar ${head.label}`}
                                      >
                                        <Iconify icon={isFiltered ? 'mdi:filter-check' : 'mdi:filter-variant'} className={`h-4 w-4 ${isFiltered ? 'text-violet-600' : 'text-gray-600 dark:text-[#ABABAD]'}`} />
                                      </Button>
                                    );
                                  })()}
                                  {head.id === 'nomeEstagio' && showEstagioFilter && (
                                    <div className="absolute top-6 left-0 z-50 bg-slate-50 dark:bg-[#222529] border dark:border-[#383838] rounded-xl shadow-lg p-3 w-56" onClick={(e) => e.stopPropagation()}>
                                      <div className="text-[11px] text-gray-500 dark:text-[#ABABAD] mb-1.5 font-medium">Filtrar estágio</div>
                                      <Select
                                        value={filterEstagio}
                                        onValueChange={(value) => {
                                          const v = value === '__all__' ? '' : value;
                                          setFilterEstagio(v);
                                          setShowEstagioFilter(false);
                                          setPage(1);
                                        }}
                                      >
                                        <SelectTrigger className="h-8 text-xs border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3]">
                                          <SelectValue placeholder="Todos" />
                                        </SelectTrigger>
                                        <SelectContent>
                                          <SelectItem value="__all__">Todos</SelectItem>
                                          {uniqueEstagios.map((n) => (
                                            <SelectItem key={n} value={n}>{n}</SelectItem>
                                          ))}
                                        </SelectContent>
                                      </Select>
                                    </div>
                                  )}
                                  {head.id === 'nomeUsuario' && showUsuarioFilter && (
                                    <div className="absolute top-6 left-0 z-50 bg-slate-50 dark:bg-[#222529] border dark:border-[#383838] rounded-xl shadow-lg p-3 w-56" onClick={(e) => e.stopPropagation()}>
                                      <div className="text-[11px] text-gray-500 dark:text-[#ABABAD] mb-1.5 font-medium">Filtrar responsável</div>
                                      <Select
                                        value={filterUsuario}
                                        onValueChange={(value) => {
                                          const v = value === '__all__' ? '' : value;
                                          setFilterUsuario(v);
                                          setShowUsuarioFilter(false);
                                          setPage(1);
                                        }}
                                      >
                                        <SelectTrigger className="h-8 text-xs border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3]">
                                          <SelectValue placeholder="Todos" />
                                        </SelectTrigger>
                                        <SelectContent>
                                          <SelectItem value="__all__">Todos</SelectItem>
                                          {uniqueUsuarios.map((n) => (
                                            <SelectItem key={n} value={n}>{n}</SelectItem>
                                          ))}
                                        </SelectContent>
                                      </Select>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </TableHead>
                        ))}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {tableData.slice((page - 1) * limit, (page - 1) * limit + limit).map((row) => (
                        <TableRow key={row._id} className="group hover:bg-gray-50/50 dark:hover:bg-[#383838]/20 transition-colors border-b border-gray-50 dark:border-[#383838]/50">
                          <TableCell className="cursor-pointer" onClick={() => {
                            handlOpenLead(row);
                            let querys = `?pipeline_id=${row.crm_pipeline_id}`;
                            buscarConfigCrmSemAlterarPipeline(querys);
                            setOpenDrawerNegocio(true);
                            if (row.clienteWhatsapp) {
                              dispatch(getMensagensWhatsappDb(row.clienteWhatsapp.sessao, row.clienteWhatsapp.numero, 1, 10));
                            }
                          }}>
                            <div className="flex items-center gap-2.5">
                              <Iconify icon="mdi:account-circle" width={16} className="text-[#7C3AED] flex-shrink-0" />
                              <span className="text-sm font-medium text-[#7C3AED] hover:underline">
                                {row.nome || 'Sem nome'}
                              </span>
                            </div>
                          </TableCell>
                          <TableCell>
                            {(() => {
                              const stagesFallback = Array.isArray(ordemColunas)
                                ? ordemColunas
                                  .map((id) => ({ _id: id, nome: colunas?.[id]?.title || colunas?.[id]?.nome || colunas?.[id]?.label || id }))
                                  .filter((s) => s.nome)
                                : [];
                              const stages = (configCrm?.stages?.length ? configCrm.stages : stagesFallback) || [];
                              if (!stages.length) {
                                return (
                                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider rounded-md bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-400">
                                    {row.nomeEstagio || 'Sem estágio'}
                                  </span>
                                );
                              }
                              return (
                                <Select
                                  defaultValue={row.estagio_pipeline_id}
                                  onValueChange={async (value) => {
                                    await editarLead('editar_estagio_funil', value, row._id);
                                    handleListaChatsFunil(periodo, pipelineId, qualificacao, responsaveis);
                                  }}
                                >
                                  <SelectTrigger className="h-7 text-xs w-[180px] border-gray-200 dark:border-[#383838] bg-slate-50 dark:bg-[#1A1D21] text-gray-900 dark:text-[#D1D2D3]">
                                    <SelectValue placeholder={row.nomeEstagio || 'Sem estágio'} />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {stages.map((stage) => (
                                      <SelectItem key={stage._id} value={stage._id}>
                                        {stage.nome}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              );
                            })()}
                          </TableCell>
                          <TableCell>
                            <span className="text-sm text-gray-600 dark:text-[#ABABAD]">
                              {row.nomeUsuario || <span className="text-gray-400 italic">Não atribuído</span>}
                            </span>
                          </TableCell>
                          <TableCell>
                            <Badge variant="outline" className={`text-[10px] font-bold uppercase tracking-wider flex items-center gap-1.5 w-fit ${getQualificacaoColor(row.qualificacao)}`}>
                              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: 'currentColor' }} />
                              {getQualificacaoLabel(row.qualificacao)}
                            </Badge>
                          </TableCell>
                          <TableCell>
                            <span className="text-sm font-semibold text-gray-900 dark:text-[#D1D2D3]">
                              {formatCurrency(row.valor)}
                            </span>
                          </TableCell>
                          <TableCell>
                            <span className="text-sm text-gray-600 dark:text-[#ABABAD]">{formatDate(row.data_criacao)}</span>
                          </TableCell>
                          <TableCell>
                            <span className="text-sm text-gray-600 dark:text-[#ABABAD]">{formatDate(row.data_modificacao)}</span>
                          </TableCell>
                          <TableCell>
                            {row.whatsapp?.numero ? (
                              <div className="flex items-center gap-1.5">
                                <Iconify icon="ri:whatsapp-fill" className="text-green-600" width={14} />
                                <span className="text-sm text-gray-600 dark:text-[#ABABAD]">{formataNumeroCelular(row.whatsapp.numero)}</span>
                              </div>
                            ) : (
                              <span className="text-gray-300 dark:text-[#565856]">-</span>
                            )}
                          </TableCell>
                          <TableCell>
                            {row.whatsapp?.nome ? (
                              <span className="text-sm text-gray-600 dark:text-[#ABABAD] truncate max-w-[150px] inline-block" title={row.whatsapp.nome}>
                                {row.whatsapp.nome}
                              </span>
                            ) : (
                              <span className="text-gray-300 dark:text-[#565856]">-</span>
                            )}
                          </TableCell>
                          <TableCell className="w-10">
                            <Button
                              variant="ghost"
                              size="sm"
                              className="h-8 w-8 p-0 rounded-lg text-gray-400 dark:text-[#ABABAD] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-500/10 opacity-0 group-hover:opacity-100 transition-all"
                              onClick={() => {
                                handlOpenLead(row);
                                let querys = `?pipeline_id=${row.crm_pipeline_id}`;
                                buscarConfigCrmSemAlterarPipeline(querys);
                                setOpenDrawerNegocio(true);
                                if (row.clienteWhatsapp) {
                                  dispatch(getMensagensWhatsappDb(row.clienteWhatsapp.sessao, row.clienteWhatsapp.numero, 1, 10));
                                }
                              }}
                              title="Ver detalhes"
                            >
                              <Iconify icon="mdi:information-outline" width={18} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>

                {/* Pagination */}
                <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100 dark:border-[#383838]">
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-[#ABABAD]">
                    <span>Exibindo</span>
                    <Select value={String(limit)} onValueChange={v => { setLimit(Number(v)); setPage(1); }}>
                      <SelectTrigger className="w-[65px] h-8 rounded-lg border-gray-200 dark:border-[#383838] dark:bg-[#1A1D21] text-sm dark:text-[#D1D2D3]">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="25">25</SelectItem>
                        <SelectItem value="50">50</SelectItem>
                        <SelectItem value="100">100</SelectItem>
                      </SelectContent>
                    </Select>
                    <span>de {tableData.length} negócios</span>
                  </div>

                  <div className="flex items-center gap-1">
                    <button
                      onClick={() => setPage(p => Math.max(1, p - 1))}
                      disabled={page <= 1}
                      className="px-3 py-1.5 text-sm text-gray-500 dark:text-[#ABABAD] hover:text-gray-900 dark:hover:text-[#D1D2D3] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    >
                      Anterior
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).slice(
                      Math.max(0, page - 3),
                      Math.min(totalPages, page + 2)
                    ).map(p => (
                      <button
                        key={p}
                        onClick={() => setPage(p)}
                        className={`w-8 h-8 rounded-lg text-sm font-medium transition-all ${p === page ? 'bg-[#7C3AED]/10 text-[#7C3AED] font-bold' : 'text-gray-500 dark:text-[#ABABAD] hover:bg-gray-100 dark:hover:bg-[#383838]'}`}
                      >
                        {p}
                      </button>
                    ))}
                    <button
                      onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                      disabled={page >= totalPages}
                      className="px-3 py-1.5 text-sm text-gray-500 dark:text-[#ABABAD] hover:text-gray-900 dark:hover:text-[#D1D2D3] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    >
                      Próxima
                    </button>
                  </div>
                </div>
              </>
            )}
          </Card>
        )}
      </div>
    </div>
  );
}
